import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  title: Yup.string().min(10).required('Required'),
  metaTitle: Yup.string().min(10).required('Required'),
  shortDescription: Yup.string().min(20).required('Required'),
  metaDescription: Yup.string().min(20).required('Required'),
  url: Yup.string().required('Required').matches(/^[a-z](-?[a-z|0-9])*$/, 'url must be a slug'),
  bannerImage: Yup.string().required('Required'),
  content: Yup.string().required('Required'),
  category: Yup.number().required('Required'),
  status: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
  carMake: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  carModel: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  carYear: Yup.array()
    .of(
      Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      })
    ).min(1).nullable(),
  theme: Yup.array()
    .of(
      Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      })
    ).min(1),
  brand: Yup.array()
    .of(
      Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      })
    ).min(1),
  relatedItem: Yup.array()
    .of(
      Yup.object().shape({
        listing_id: Yup.string(),
      })
    ).nullable()
});

export default validationSchema;
